/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


(function() {
  var style = document.createElement('style');
  style.innerHTML = `
    [data-section-id="1609146383bf168ee6"] { background-color: #2D1B69 !important; }
    [data-section-id="1609146383bf168ee6"] h1,[data-section-id="1609146383bf168ee6"] h2,[data-section-id="1609146383bf168ee6"] h3 { color: #FFD700 !important; }
    [data-section-id="1609146383bf168ee6"] p,[data-section-id="1609146383bf168ee6"] span { color: #F0ECFF !important; }

    [data-section-id="160914639645a87303"] { background-color: #0D3B4F !important; }
    [data-section-id="160914639645a87303"] h1,[data-section-id="160914639645a87303"] h2,[data-section-id="160914639645a87303"] h3 { color: #B8F0E6 !important; }
    [data-section-id="160914639645a87303"] p,[data-section-id="160914639645a87303"] span { color: #FFFFFF !important; }

    [data-section-id="1609150125a009ec62"] { background-color: #1E1245 !important; }
    [data-section-id="1609150125a009ec62"] h1,[data-section-id="1609150125a009ec62"] h2,[data-section-id="1609150125a009ec62"] h3 { color: #FFD700 !important; }
    [data-section-id="1609150125a009ec62"] p,[data-section-id="1609150125a009ec62"] span { color: #F0ECFF !important; }

    [data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] { background-color: #3B0A45 !important; }
    [data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] h1,[data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] h2,[data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] h3 { color: #F9C6FF !important; }
    [data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] p,[data-section-id="2657f289-c018-40cd-b2da-8f482e6a2873"] span { color: #FFFFFF !important; }

    [data-section-id="featured_collections_j7NTMz"] { background-color: #0A2E1F !important; }
    [data-section-id="featured_collections_j7NTMz"] h1,[data-section-id="featured_collections_j7NTMz"] h2,[data-section-id="featured_collections_j7NTMz"] h3 { color: #B8F0E6 !important; }
    [data-section-id="featured_collections_j7NTMz"] p,[data-section-id="featured_collections_j7NTMz"] span { color: #F0ECFF !important; }
  `;
  document.head.appendChild(style);
})();
